<template>
  <div class="card">
    <div class="card-content">
      <div>
        <strong>Vessel IMO</strong>
        <div class="content" v-if="shipment.conventional_shipment && shipment.conventional_shipment.vessel.imo">{{ shipment.conventional_shipment.vessel.imo }}</div>
        <div class="content" v-else>{{ shipment.vessel_imo }}</div>
      </div>
      <div v-if="shipment.conventional_shipment && shipment.conventional_shipment.vessel.name">
        <strong>Vessel Name</strong>
        <div class="content">{{ shipment.conventional_shipment.vessel.name }}</div>
      </div>
      <div v-if="shipment.conventional_shipment && shipment.conventional_shipment.vessel.mmsi">
        <strong>Vessel MMSI</strong>
        <div class="content">{{ shipment.conventional_shipment.vessel.mmsi }}</div>
      </div>
      <div v-if="shipment.conventional_shipment && shipment.conventional_shipment.vessel.type">
        <strong>Type</strong>
        <div class="content">{{ TYPE_VESSEL[shipment.conventional_shipment.vessel.type] }}</div>
      </div>
    </div>
    <div class="card-content" v-if="shipment.conventional_shipment && shipment.conventional_shipment.milestone">
      <article class="media">
        <figure class="media-left">
          <span class="fa fa-check-circle fa-fw has-text-success is-size-3"></span>
        </figure>
        <div class="media-content">
          <div class="content">
            <p class="has-text-success">{{ MILESTONE[shipment.conventional_shipment.milestone] }}</p>
            <small></small>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>
 
<script>
import conventionalShipment from '@/models/conventional/shipment'
export default {
  name: 'shipment',
  props: ['shipment'],
  computed: {},
  data () {
    return {
      TYPE_VESSEL: conventionalShipment.TYPE_VESSEL,
      STATUS: conventionalShipment.VESSEL_STATUS,
      MILESTONE: conventionalShipment.MILESTONE
    }
  },
  methods: {
    notEmptyObject (someObject) {
      if (someObject) {
        var parsedobj = JSON.parse(JSON.stringify(someObject))
        return Object.keys(parsedobj).length
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/conventional/ShipmentConventionalCard.vue